import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"
import { cva } from "class-variance-authority"

import { cn } from "@/lib/utils"

const labelVariants = cva(
    "font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
    {
        variants: {
            variant: {
                default: "",
                required: "after:content-['*'] after:ml-0.5 after:text-destructive",
                optional: "after:align-middle after:content-['Facultatif'] after:ml-3 after:bg-muted after:py-0.5 after:px-1 after:text-xs after:rounded-[3px] after:text-muted-foreground",
            }
        },
        defaultVariants: {
            variant: "default",
        },
    }
)

const Label = React.forwardRef(({ className, variant, ...props }, ref) => (
    <LabelPrimitive.Root ref={ref} className={cn(labelVariants({ variant }), className)} {...props} />
))
Label.displayName = LabelPrimitive.Root.displayName

export { Label }
